import * as TypeGraphQL from "type-graphql";
export var ConflictResolutionStrategy;
(function (ConflictResolutionStrategy) {
    ConflictResolutionStrategy["SERVER_WINS"] = "SERVER_WINS";
    ConflictResolutionStrategy["CLIENT_WINS"] = "CLIENT_WINS";
    ConflictResolutionStrategy["MERGE"] = "MERGE";
    ConflictResolutionStrategy["MANUAL"] = "MANUAL";
    ConflictResolutionStrategy["TIMESTAMP_BASED"] = "TIMESTAMP_BASED";
})(ConflictResolutionStrategy || (ConflictResolutionStrategy = {}));
TypeGraphQL.registerEnumType(ConflictResolutionStrategy, {
    name: "ConflictResolutionStrategy",
    description: undefined,
});
//# sourceMappingURL=ConflictResolutionStrategy.js.map